import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import './FadeElement.css';

const defaultStyle = {
  maxHeight: 0,
  opacity: 1
};

const transitionStyles = {
  entering: { animation: 'growHeight 1.4s ease forwards', opacity: 1 },
  entered: { maxHeight: 'none', opacity: 1 },
  exiting: {
    transition: 'opacity 300ms ease-in-out',
    opacity: 0,
    maxHeight: 'none'
  },
  exited: {
    transition: 'opacity 300ms ease-in-out',
    opacity: 0,
    maxHeight: 'none'
  }
};

class FadeElement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      in: props.in
    };
  }

  componentDidMount() {
    this.setState({ in: true });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Transition
          in={this.state.in && !this.props.removing}
          mountOnEnter={false}
          timeout={{
            enter: 1400,
            exit: 300
          }}
          onEntered={() => {
            this.props.onTransitionComplete &&
              this.props.onTransitionComplete();
          }}
          onExited={() => {
            this.props.onRemoveComplete && this.props.onRemoveComplete();
          }}
        >
          {state => (
            <div
              style={{
                ...defaultStyle,
                ...transitionStyles[state]
              }}
            >
              {this.props.children}
            </div>
          )}
        </Transition>
      </div>
    );
  }
}

FadeElement.propTypes = {
  onTransitionComplete: PropTypes.func,
  onRemoveComplete: PropTypes.func,
  styles: PropTypes.object,
  removing: PropTypes.bool
};

export default FadeElement;
